import { DomSanitizer } from '@angular/platform-browser';
var OverdueDebtComponent = (function () {
    function OverdueDebtComponent(sanitizer) {
        this.sanitizer = sanitizer;
        this.url = 'https://app.powerbi.com/view?r=eyJrIjoiZTE1YTk3NDUtYzJiNS00MjRhLWI4ODMtYzU5NTg2YTQ0NDM2IiwidCI6ImNkZDY0NWJmLTE3MzEtNGQzNy05Mjc1LThiOWEwZjNlZTYwNCIsImMiOjEwfQ%3D%3D';
    }
    OverdueDebtComponent.prototype.ngOnInit = function () {
        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
    };
    return OverdueDebtComponent;
}());
export { OverdueDebtComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/power-bi-dashboard/overdue-debt/overdue-debt.component.ts.pre-build-optimizer.js